var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-snake',{attrs:{"steps":_vm.months,"color":_vm.color,"start":_vm.start,"end":_vm.end,"labels":_vm.labels}})
}
var staticRenderFns = []

export { render, staticRenderFns }